import React from 'react';
import { HeroVariant25 } from '../components/HeroVariant25';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage25() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1561">
      <Navigation data-id="element-1562" />
      <main data-id="element-1563">
        <HeroVariant25 data-id="element-1564" />
        <WhyUs data-id="element-1565" />
        <Services data-id="element-1566" />
        <FAQ data-id="element-1567" />
        <Testimonials data-id="element-1568" />
        <Consultation data-id="element-1569" />
      </main>
      <Footer data-id="element-1570" />
      <CookieBanner data-id="element-1571" />
      <FloatingContact data-id="element-1572" />
    </div>;
}